/* eslint-disable camelcase -- mirrors the external API's snake_case field names */
import { IIntercomSettings } from './intercom-settings.interface';

export const SESSION_DURATION_INTERCOM = 500;
export const MAIN_COLOR = '#2C9C74';
export const VERTICAL_PADDING_NON_AUTHENTICATED = 50;
export const PRODUCT_TYPE_INTERCOM = 'VDR';

export class IntercomSettings {
  readonly action_color: string;
  readonly alignment?: 'right' | 'left';
  readonly app_id: string;
  readonly background_color: string;
  readonly enabled: boolean;
  readonly IP: string;
  readonly product_type: string;
  readonly session_duration: number;
  readonly vertical_padding: number;

  constructor({
    app_id,
    ip,
    enabled,
    background_color,
    action_color,
    session_duration,
    alignment,
  }: IIntercomSettings) {
    this.app_id = app_id;
    this.IP = ip;
    this.background_color = background_color || MAIN_COLOR;
    this.action_color = action_color || MAIN_COLOR;
    this.enabled = enabled;
    this.vertical_padding = VERTICAL_PADDING_NON_AUTHENTICATED;
    this.session_duration = session_duration || SESSION_DURATION_INTERCOM;
    this.product_type = PRODUCT_TYPE_INTERCOM;
    this.alignment = alignment;
  }
}
